import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';
import { nuc } from '../../../utils';
import { getUseNoticeFilesQueryKey } from '../revisions/useNoticeFiles';
import { getQueryKey as getRevisionQueryKey } from '../revisions/useRevision';
import type { NoticeMatchCorrectionRequest } from '../../../../shared/types/routes/revisions';

const upsertNoticeFileCorrection = async ({
  correctionData,
  dependencyRevisionLocator,
}: {
  correctionData: NoticeMatchCorrectionRequest[];
  dependencyRevisionLocator: string;
}): Promise<void> => {
  await put(`/api/v2/revisions/${nuc(dependencyRevisionLocator)}/correction/notice-files`, { data: correctionData });
};

export const useCorrectNoticeFile = (dependencyRevisionLocator: string) => {
  return useToastedMutation({
    mutationFn: (correctionData: NoticeMatchCorrectionRequest[]) =>
      upsertNoticeFileCorrection({ correctionData, dependencyRevisionLocator }),
    successToastMessage: 'Notice file correction saved successfully',
    errorToastMessage: 'Failed to save notice file correction',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getUseNoticeFilesQueryKey(dependencyRevisionLocator) });
      queryClient.invalidateQueries({ queryKey: getRevisionQueryKey(dependencyRevisionLocator) });
    },
  });
};
